import { useEffect, useState } from "react";
import { useLocation } from "@remix-run/react";

import { useIntroSetup } from "~/hooks/useIntroSetup";
import { QuizProvider, useQuizState } from "~/hooks/useQuizState";
import { ClientSideLoader } from "~/components/shared/ClientSideLoader";

import { QuizLayout } from "../QuizLayout";
import { AlreadyUsedIntroOrderModal } from "../AlreadyUsedIntroOrderModal";

function QuizWrapperContent({
  location,
  customerId,
  subscriptionStatus,
  initialStep,
}) {
  const { setUserData } = useQuizState();
  const [step, setStep] = useState(Number(initialStep));

  useIntroSetup();

  useEffect(() => {
    setUserData({ customerId, subscriptionStatus });
  }, [customerId, subscriptionStatus, setUserData]);

  // Support client-side navigation since we can't revalidate the loader in the route,
  // Otherwise, we will face issues with the Shopify's HMAC validation.
  useEffect(() => {
    const stepFromUrl = location.pathname.split("/").pop();
    // Fallback to first step if the step is not a number
    const stepFromUrlNumber = !isNaN(stepFromUrl) ? Number(stepFromUrl) : 1;

    if (stepFromUrlNumber !== step) {
      setStep(Number(stepFromUrlNumber));
    }
  }, [location.pathname, step]);

  return (
    <>
      <AlreadyUsedIntroOrderModal />
      <QuizLayout step={step} />
    </>
  );
}

export function QuizWrapper({
  step: initialStep,
  customerId,
  subscriptionStatus,
}) {
  const location = useLocation();

  return (
    <ClientSideLoader>
        <QuizWrapperContent
          location={location}
          customerId={customerId}
          subscriptionStatus={subscriptionStatus}
          initialStep={initialStep}
        />
    </ClientSideLoader>
  );
}
